import { fetcher } from 'redux/apisTools';
import { OptionMappings } from 'types';
import makeGetHook from '@eGroupTeam/hooks/makeGetHook';

const useOptions = makeGetHook<OptionMappings>('/option-mappings', fetcher);
export default useOptions;
